import { css } from 'lit';

export const homeStyles = css`
  :host {
    display: block;
    height: 100vh;
  }

  /* ── Desktop layout (> 768px): sidebar pushes content ── */
  .app-grid {
    display: grid;
    grid-template-areas:
      'sidebar header'
      'sidebar main'
      'sidebar footer';
    grid-template-columns: 12em 1fr;
    grid-template-rows: auto 1fr auto;
    height: 100vh;
    transition: grid-template-columns 0.2s ease;
  }

  .app-grid.drawer-closed {
    grid-template-columns: 0 1fr;
  }

  /* ── Sidebar ── */
  aside {
    grid-area: sidebar;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: var(--drawer-background);
    border-right: 1px solid var(--drwaer-border-color);
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    z-index: 4;
  }

  .sidebar-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    flex-shrink: 0;
  }

  .logo {
    width: 90%;
    height: auto;
    display: block;
  }

  .nav-top {
    flex: 1;
    padding: 4px 0;
  }

  .nav-bottom {
    border-top: 1px solid var(--lumo-contrast-10pct);
    padding: 8px;
    flex-shrink: 0;
  }

  /* ── Header ── */
  header {
    grid-area: header;
    display: flex;
    align-items: center;
    gap: 12px;
    padding-inline: 1rem;
    height: 46px;
    background-color: var(--navbar-header-color);
    border-bottom: 1px solid var(--drwaer-border-color);
    z-index: 3;
  }

  .menu-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    color: var(--font-color);
    flex-shrink: 0;
  }

  .header-actions {
    display: flex;
    align-items: center;
    margin-left: auto;
    min-width: 0;
  }

  .header-actions.hidden {
    display: none;
  }

  /* .header-actions vaadin-select {
    width: 200px;
  } */

  /* .header-actions vaadin-select::part(value) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  } */

  /* ── Main ── */
  main {
    grid-area: main;
    overflow-y: auto;
    /* overflow-x: hidden; */
    min-height: 0;
    padding: 8px;
    /* box-sizing: border-box; */
    background-color: var(--background-color);
  }

  /* ── Footer ── */
  footer {
    grid-area: footer;
    height: 32px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    font-size: 0.75rem;
    color: var(--lumo-secondary-text-color);
    background-color: var(--footer-bg, var(--lumo-contrast-5pct));
    border-top: 1px solid var(--drwaer-border-color);
  }

  /* ── Nav items ── */
  .material-icons {
    font-family: 'Material Icons';
    font-size: 16px;
    color: var(--icon-color);
  }

  vaadin-side-nav-item::part(content) {
    color: var(--text-primary);
    font-weight: 400;
  }

  /* vaadin-side-nav-item[current]::part(content) {
    background-color: var(--selected-nav-color);
    border-radius: 0;
  } */

  /* vaadin-side-nav-item:hover::part(content) {
    cursor: pointer;
  } */

  /* vaadin-side-nav-item:hover .nav-item-label {
    color: var(--drawer-hover-color);
  }

  vaadin-side-nav-item[current]:hover .nav-item-label {
    color: var(--text-primary);
  }

  vaadin-side-nav::part(toggle-button) {
    color: var(--lumo-primary-text-color);
  } */

  .nav-last span[slot='label'] {
    padding: 0 0 0 8px;
    font-size: 0.8em;
    color: var(--lumo-primary-text-color);
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  /* ── Select in header ── */
  /* vaadin-select::part(toggle-button) {
    color: var(--text-primary);
  } */

  /* vaadin-select {
    background-color: var(--drwaer-border-color);
    border-bottom: 1px solid white;
    color: var(--text-primary);
    border-radius: 5px;
  } */

  /* vaadin-select[readonly]::part(toggle-button) {
    display: none;
  } */
  
  vaadin-select-item[selected] {
    color: var(--text-primary);
  }

  /* ── Backdrop (mobile only) ── */
  .backdrop {
    display: none;
  }

  /* ── Mobile layout (≤ 768px): sidebar overlays, no grid column ── */
  @media (max-width: 768px) {
    .app-grid {
      grid-template-columns: 1fr;
      grid-template-areas:
        'header'
        'main'
        'footer';
    }

    /* drawer-closed has no effect on grid in mobile — aside is fixed */
    .app-grid.drawer-closed {
      grid-template-columns: 1fr;
    }

    aside {
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 12em;
      z-index: 5;
      transform: translateX(0);
      transition: transform 0.2s ease;
    }

    .app-grid.drawer-closed aside {
      transform: translateX(-100%);
    }

    .backdrop {
      display: block;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.4);
      z-index: 4;
    }

    main {
      max-width: 100vw;
    }
  }
`;
